/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useRef } from 'react';
import { Divider } from '@blueprint/ui';
import { ArrowheadDownSmall, ArrowheadUpSmall } from '@blueprint/icons';

import {
    Container,
    TextContainer,
    ToggleButton,
    RichText
} from './TruncatedText.styles';
import { TruncatedTextProps } from './TruncatedText.types';
import { useTruncatedText } from './TruncatedText.hooks';

const TruncatedText = ({
    text,
    lines = 3,
    labelExpanded = 'Show less',
    labelContracted = 'Show more',
    onExpand,
    onContract
}: TruncatedTextProps) => {
    const textRef = useRef<HTMLDivElement>(null);
    const { height, isTruncated, isExpanded, setExpanded } = useTruncatedText(
        textRef,
        lines
    );

    useEffect(() => {
        setExpanded(false);
    }, [text]);

    const toggle = () => {
        if (isExpanded) {
            // We are contracting
            onContract && onContract();
            setExpanded(false);
        } else {
            // We are expanding
            onExpand && onExpand();
            setExpanded(true);
        }
    };

    const label = isExpanded ? labelExpanded : labelContracted;
    const icon = isExpanded ? <ArrowheadUpSmall /> : <ArrowheadDownSmall />;

    return (
        <Container>
            <TextContainer
                isExpanded={isExpanded}
                lines={lines}
                height={height}
                data-testid="truncated_text_container"
            >
                <RichText ref={textRef}>{text}</RichText>
            </TextContainer>
            {isTruncated && (
                <>
                    <Divider variant="horizontal" />
                    <ToggleButton variant="tertiary" onClick={toggle}>
                        {icon}
                        {label}
                    </ToggleButton>
                </>
            )}
        </Container>
    );
};

export default TruncatedText;
